import styled from 'styled-components';

export const StyledHeader = styled.header<{ $emptyHeader?: boolean; backgroundUrl?: string; $hasNavigation: boolean }>`
  background: ${(props) => (props.$emptyHeader ? props.theme.color.secondaryGradient : '')};
  background-image: ${(props) => (props.$emptyHeader ? 'none' : `url("${props.backgroundUrl}")`)};
  background-size: cover;
  background-position: center;
  color: white;
  height: ${(props) => (props.$emptyHeader ? '400px' : '800px')};
  margin-top: ${(props) => (props.$hasNavigation ? '45px' : '0')};
  padding-top: 100px;
  text-align: center;
`;

export const StyledHeaderContent = styled.div`
  color: ${(props) => props.theme.color.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const StyledHeaderTitle = styled.h1<{ $emptyHeader?: boolean }>`
  color: ${(props) => (props.$emptyHeader ? props.theme.color.bodyTextColor : props.theme.color.white)};
  font-size: 84px;
  line-height: 100.8px;

  @media (max-width: 1024px) {
    font-size: 64px;
  }

  @media (max-width: 768px) {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const StyledHeaderSubTitle = styled.h2<{ $emptyHeader?: boolean }>`
  color: ${(props) => (props.$emptyHeader ? props.theme.color.bodyTextColor : props.theme.color.white)};
  font-size: 48px;
  line-height: 57px;
`;
